/* eslint-disable no-console */
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { TokenProviderService } from '../services/token-provider.service';
import { AppRoutingKeys } from '@shared';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationGuard {
	public constructor(
		private tokenProviderService: TokenProviderService,
		private router: Router
	) {}

	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	public async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		const token = await this.tokenProviderService.get();
		if (token) {
			return true;
		}
		this.router.navigate([`/${AppRoutingKeys.urlPathLogin}`]);
		return false;
	}
}
